import React from "react";
import { Row, Col } from "antd";
import TextField from "../TextField";

/**
 * Reusable Name Fields Row Component
 * Combines First, Middle, and Last name fields in a row layout
 *
 * @param {boolean} readOnly - Whether fields are read-only
 * @param {boolean} showMiddleName - Whether to show middle name field
 * @param {object} firstNameProps - Additional props for first name field
 * @param {object} middleNameProps - Additional props for middle name field
 * @param {object} lastNameProps - Additional props for last name field
 */
const NameFieldsRow = ({
  readOnly = false,
  showMiddleName = true,
  firstNameProps = {},
  middleNameProps = {},
  lastNameProps = {},
}) => (
  <Row gutter={16}>
    <Col span={showMiddleName ? 12 : 12}>
      <TextField
        name="firstName"
        label="First Name"
        placeholder="e.g John"
        required
        readOnly={readOnly}
        {...firstNameProps}
      />
    </Col>

    {showMiddleName && (
      <Col span={12}>
        <TextField
          name="middleName"
          label="Middle Name"
          placeholder="e.g Michael"
          readOnly={readOnly}
          {...middleNameProps}
        />
      </Col>
    )}

    <Col span={showMiddleName ? 12 : 12}>
      <TextField
        name="lastName"
        label="Last Name"
        placeholder="e.g Doe"
        required
        readOnly={readOnly}
        {...lastNameProps}
      />
    </Col>
  </Row>
);

export default NameFieldsRow;
